import { SnackbarProvider } from "notistack";
import { useGetContext } from "@onefront/forrestjs-react-root";

export const NotistackWrapper = ({ children }) => (
  <SnackbarProvider {...useGetContext("notistack")}>
    {children}
  </SnackbarProvider>
);
